(() => {
    // pause audio/video on modal close
    document.getElementById('mediaModal').addEventListener('hidden.bs.modal', () => {
        const videoJsElement = document.querySelector('.video-js');
        if (videoJsElement) {
            const player = videoJsElement.player; // Assuming player is a property of the video element
            if (player) {
                player.pause();
            }
        }

        const audioElement = document.querySelector('#hero-audio audio');
        if (audioElement) {
            audioElement.pause();

            const playPauseElement = document.querySelector('#hero-audio .playPause');
            if (playPauseElement) {
                playPauseElement.setAttribute(
                    'd',
                    'M27.1214286,17.1649042 L14.55,9.225677 C13.4214286,8.5727312 12,9.41117296 12,10.7838431 L12,26.2171073 C12,27.5823576 13.4142857,28.4282192 14.55,27.7752734 L27.1214286,20.2812364 C28.2928571,19.6060311 28.2928571,17.8475294 27.1214286,17.1649042 Z'
                );
            }
        }
    });
})();
